<template>
  <div>
    <listFilter :formItems="filterItems" :filter="filterModel" @selectChange="searchTableInfo" @searchTableInfo="searchTableInfo"></listFilter>
    <slot name="listOperate"></slot>
    <Table border stripe highlight-row :columns="columns" size="small" :data="dataArr"  :row-class-name="setRowClass"></Table>
    <div style="margin: 10px; overflow: hidden;">
      <div style="float: right;">
        <Page show-total :total="totalCount" :current="filterModel.pageNum" :page-size="filterModel.pageSize" @on-change="changePage"></Page>
      </div>
    </div>
    <slot name="modalTpl"></slot>
  </div>
</template>
<script>
export default {
  name: 'CustomList',
  props: {
    listUrl: { // 列表ajax url
      type: String,
      required: true
    },
    ajaxType: { // ajax 的类型
      type: String,
      default: 'get',
      validator (value) {
        return ['get', 'post'].some(val => val == value); // 只能是get和post之一
      }
    },
    filterItems: { // 筛选字段
      type: Array,
      required: true
    },
    filterModel: { // 筛选模型
      type: Object,
      required: true
    },
    columns: { // 表格的列配置
      type: Array,
      required: true
    },
    getListBefore: { // 获取列表前的函数
      type: Function
    },
    setRowClass: { // 指定行添加css
      type: Function
    }
  },
  data () {
    return {
      dataArr: [],
      totalCount: 0
    };
  },
  methods: {
    searchTableInfo () {
      this.filterModel.pageNum = 1;
      this.getTableInfo();
    },
    // 翻页
    changePage (num) {
      this.filterModel.pageNum = num;
      this.getTableInfo();
    },
    // 切换每页条数
    changePageSize (size) {
      this.filterModel.pageSize = size;
      this.getTableInfo();
    },
    // 获取在途客户列表
    getTableInfo () {
      // 调用getListBefore
      // eslint-disable-next-line no-unused-expressions
      this.getListBefore && typeof this.getListBefore === 'function' ? this.getListBefore : '';
      const type = this.ajaxType === 'get' ? 'get' : 'post'; // 参数校验
      this.$ajax[type](this.listUrl, { params: this.filterModel }).then((res) => {
        this.dataArr = res.data.list || [];
        this.totalCount = res.data.total;
      });
    }
  },
  mounted () {
    this.searchTableInfo();
  }
};
</script>
